// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"fab9c75b","161":"17bcd775","239":"e7a2ff17","241":"76f26891","355":"0a534ae6","396":"6d76ce65","455":"22a13694","673":"e0c589fd","715":"f88fa79b","722":"c4662f89","857":"44e4468d","882":"81d31255","889":"784a3eba","977":"a723575a"}[chunkId] + ".chunk.js";
};